import React from 'react'

const NewsItem = (props) => {

  let { title, description, imgurl, newsurl, author, date, source } = props;
  return (

    <div className="card-group my-3">
      <div className="card " style={{
        border: "solid 3px black",
        minWidth: "300px",
        maxWidth: "100%",
        minHeight: "520px", // adjust height as needed to fit content
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}>
        <img
          src={!imgurl ? "https://assets.thehansindia.com/h-upload/2020/05/14/969258-liveupdates.webp" : imgurl}
          className="card-img-top"
          alt="news"
          style={{
            maxWidth: "100%",
            minHeight: "200px",
            maxHeight: "200px",
            objectFit: "cover"
          }}
        />
        <div className="card-body text-center" style={{
          padding: "1rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flexGrow: 1
        }}>
          <h5 className="card-title" style={{ color: "rgb(2 0 90)", fontWeight: "700", minHeight: "60px" }}>{title}...<span className="position-absolute top-0 translate-middle badge rounded-pill bg-warning text-dark" style={{ left: "50%", zIndex: "1", border: "solid 2px black" }}> {source}
            <span className="visually-hidden">unread messages</span>
          </span> </h5>
          <p
            className="card-text"
            style={{
              color: "black",
              fontWeight: "500",
              maxHeight: "100px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 3, // controls how many lines to show
              WebkitBoxOrient: "vertical"
            }}
          >
            {description}
          </p>
          <p className="card-text" style={{ color: "rgb(8 5 177)", fontWeight: "450" }}><small className="text">By {!author ? "Unknown" : author} on {new Date(date).toUTCString()} </small></p>
          <a href={newsurl} target='_blank' rel="noreferrer" className=" btn btn-dark ">Know More</a>
        </div>
      </div>
    </div>

  )

}

export default NewsItem
